import Highcharts from 'highcharts';

import {
  DEFAULT_CV,
  DEFAULT_PRICES,
  SIZE_CLASSES,
  expectedRevenueByClassPerGroup,
} from 'views/bluviu-nutrition/features/scenarios-v2/utils/expected-revenue-calculations';
import { ExpectedSalesPriceGraphValue } from 'views/bluviu-nutrition/features/scenarios-v2/types/expected-sales-price-graph.type';

const buildTotalValueBySizeClassSeries = (graphValues: ExpectedSalesPriceGraphValue[]): Highcharts.SeriesLineOptions[] => {
  const weekMap = new Map<number, Record<string, number>>();

  graphValues.forEach(({ productionWeek: week, guttedWeightEndOfWeek, fishEndWeek }) => {
    if (!weekMap.has(week)) {
      weekMap.set(week, Object.fromEntries(SIZE_CLASSES.map((c) => [c.label, 0])));
    }

    const point = weekMap.get(week)!;
    const byClass = expectedRevenueByClassPerGroup({ guttedWeightEndOfWeek, fishEndWeek }, DEFAULT_CV, DEFAULT_PRICES);

    for (const { label } of SIZE_CLASSES) {
      point[label] = (point[label] ?? 0) + (byClass[label] ?? 0);
    }
  });

  const sortedWeeks = [...weekMap.entries()].sort(([a], [b]) => a - b);

  return SIZE_CLASSES.map((c) => ({
    type: 'line',
    name: c.label,
    data: sortedWeeks.map(([week, point]) => [week, point[c.label] ?? 0] as [number, number]),
    marker: { enabled: false, symbol: 'circle' },
  }));
};

export default buildTotalValueBySizeClassSeries;
